import requestMaker from "lib";

export const getBrandConfig = (params) => {
    const baseQuery = `/proxy/prv/bs/gbc`;
    return requestMaker(baseQuery, { params, payload: {} });
}